export default "__VITE_ASSET__U95_uYFj__"